/* eslint-disable react/prop-types */
import React from "react";
import PropTypes from "prop-types";
import Datetime from "react-datetime";

// @material-ui/core
import withStyles from "@material-ui/core/styles/withStyles";

import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import Box from "@material-ui/core/Box";
import Modal from "@material-ui/core/Modal";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import CloseIcon from "@material-ui/icons/Close";
import DeleteIcon from "@material-ui/icons/Delete";

// core component
import ReactEcharts from "echarts-for-react";
import Button from "components/CustomButtons/Button.jsx";
import CustomSelect from "components/CustomSelect/CustomSelect.jsx";

import {
  getUserDevices,
  downloadDeviceData
} from "../../services/dashboardDataProvider";

import "react-circular-progressbar/dist/styles.css";

import { dayjs } from "utils/time.jsx";

const styles = {
  img: {
    width: "auto",
    height: "auto",
    verticalAlign: "middle",
    border: "0"
  },
  loadOnImg: {
    width: "60px",
    height: "auto",
    backgroundColor: "lightgreen"
  },
  loadOffImg: {
    width: "60px",
    height: "auto"
  },
  cardTitleBlack: {
    color: "#273746",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "600",
    fontFamily: "'Josefin Sans', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
  },
  cardIconTitle: {
    color: "#3C4858",
    margin: "10px 0 0",
    fontWeight: "300"
  },
  statusSummaryContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly"
  },
  statusSummaryIndicatorsContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    flexWrap: "wrap"
  },
  statusSummaryItem: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-evenly",
    margin: "10px"
  },
  StatusSummaryItemTitle: {
    minWidth: "130px !important"
  },
  StatusSummaryItemWidget: {
    width: "auto"
  },
  statusItemChip: {
    marginTop: "15px"
  },
  statusSummaryControls: {
    margin: "10px"
  },
  cardIcon: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  },
  deviceInfoHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap",
    background: "hsla(0,0%,98%,.85)",
    boxShadow: "0px 0px 1px 0 hsl(0deg 0% 6% / 40%)",
    borderRadius: "20px"
  },
  deviceInfo: {
    padding: "10px"
  },
  deviceWeatherInfo: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "10px"
  },
  cityName: {
    display: "flex",
    flexDirection: "column",
    alignItems: "baseline"
  },
  cityTemperature: {
    color: "#1e2432",
    fontSize: "3rem",
    fontWeight: "200",
    textAlign: "center"
  },
  cityWeatherImage: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
  },
  cityWeatherIcon: {
    height: "100px",
    width: "100px"
  },
  rawTelemetryDataContainer: {
    display: "flex",
    flexDirection: "column",
    overflowX: "scroll"
  },
  jsonContainer: {
    display: "flex",
    flexDirection: "column"
  },
  jsonKeyValuePair: {
    display: "flex",
    flexDirection: "row"
  },
  jsonKey: {
    fontSize: "larger",
    color: "#0057ff",
    display: "flex",
    flexDirection: "row"
  },
  jsonKeyValue: {
    display: "flex",
    flexDirection: "row",
    color: "#ff00a0",
    paddingLeft: "5px"
  },
  updateInfo: {
    color: "blue"
  },
  dataUpdateInfo: {
    color: "blueviolet"
  },
  updateInfoLabel: {
    color: "blue"
  },
  dataUpdateInfoLabel: {
    color: "blueviolet"
  },
  chartSelectionContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  chartTypeLabel: {
    paddingRight: "10px"
  },
  dataSourceSelector: {
    width: "115px !important"
  },
  alarmActions: {
    display: "flex",
    justifyContent: "flex-end"
  },
  alarmModalBox: {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    opacity: "100%",
    zIndex: 2000,
    backgroundColor: "white",
    borderRadius: "10px",
    border: "1px solid rgba(0, 0, 0, 0.3)",
    "-webkit-box-shadow": "0 3px 7px rgba(0, 0, 0, 0.3)",
    "-moz-box-shadow": "0 3px 7px rgba(0, 0, 0, 0.3)",
    boxShadow: "0 3px 7px rgba(0, 0, 0, 0.3)",
    "-webkit-background-clip": "padding-box",
    "-moz-background-clip": "padding-box",
    backgroundClip: "padding-box"
  },
  alarmSelectionContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px"
  },
  deviceLogActions: {
    display: "flex",
    justifyContent: "flex-end",
    flexDirection: "column"
  },
  deviceLogs: {
    whiteSpace: "pre-line",
    background: "black",
    color: "aliceblue",
    overflow: "scroll",
    maxHeight: "400px"
  },
  chartFiltersContainer: {
    border: "1px solid #ccc",
    padding: "10px",
    borderRadius: "5px"
  },
  chartHeaderContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  }
};

const AVAILABLE_DATA_SOURCES = [
  { text: "Status Data", value: "status" },
  { text: "Raw Data", value: "raw_data" }
];

class AdvancedCharts extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      deviceId: null,
      devices: [],
      showTodaysStatus: true,
      editDeviceDetails: false,
      showRawData: false,
      selectedDataSource: AVAILABLE_DATA_SOURCES[0].text,
      alarmModalOpen: false,
      deviceLogs: null,
      logsInputData: {
        date: null,
        logSearchPattern: ""
      }
    };
  }

  componentDidMount() {
    // eslint-disable-next-line react/prop-types
    let deviceId =
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.deviceId;
    if (deviceId) {
      getUserDevices(this.props.axios, deviceId).then(data => {
        this.setState({ deviceId: deviceId, deviceData: data });
      });
    }
  }

  onChange = (dictName, propName) => e => {
    const value = e.target.value;
    if (dictName == null || dictName === "") {
      this.setState({ [propName]: value });
    } else {
      let updatedData = this.state[dictName] || {};
      updatedData[propName] = value;
      this.setState({ [dictName]: updatedData });
    }
  };

  addNewChart = () => {
    const existingCharts = this.state.visibleCharts || [];
    existingCharts.push({
      date: null,
      selectedDataSource: "power"
    });
    this.setState({ visibleCharts: existingCharts });
  };

  onChartInputsChange = (idx, propName) => e => {
    const value = (e.target && e.target.value) || e;
    const visibleCharts = this.state.visibleCharts || [];
    if (visibleCharts[idx] == null) {
      visibleCharts[idx] = {};
    }
    visibleCharts[idx][propName] = value;
    this.setState({ visibleCharts: visibleCharts });
    let deviceId =
      this.state.deviceId ||
      (this.props.deviceData && this.props.deviceData.ip_address);
    if (
      deviceId &&
      [
        "startDate",
        "startTime",
        "endDate",
        "endTime",
        "dataType",
        "exportType"
      ].includes(propName)
    ) {
      let payload = {};
      let payloadInput = visibleCharts[idx] || {};
      payload["exportType"] = "json";
      payload["startDate"] = payloadInput["startDate"];
      payload["endDate"] = payloadInput["endDate"];
      payload["startTime"] = payloadInput["startTime"];
      payload["endTime"] = payloadInput["endTime"];
      payload["dataType"] = payloadInput["dataType"];
      if (payload.dataType == null) {
        return;
      }
      if (payload.endDate == null) {
        payload["endDate"] = payload["startDate"];
      }
      if (payload.endTime == null) {
        payload["endTime"] = payload["startTime"];
      }
      if (payload.startTime != null) {
        payload["startTime"] = dayjs(payload["startTime"]).format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        );
      }
      if (payload.endTime != null) {
        payload["endTime"] = dayjs(payload["endTime"]).format(
          "YYYY-MM-DDTHH:mm:ss[Z]"
        );
      }
      downloadDeviceData(this.props.axios, deviceId, payload).then(data => {
        visibleCharts[idx]["statusData"] = data;
        let pairs = this.createFilterableKeyValuePairs(data);
        visibleCharts[idx]["dataKeys"] = pairs[0];
        visibleCharts[idx]["plotableKeys"] = pairs[1];
        this.setState({ visibleCharts: visibleCharts });
      });
    }
  };

  onChartFilersKeyChange = idx => e => {
    let keyName = e.target && e.target.value;
    if (keyName == null && typeof e === "string") {
      keyName = e;
    }
    const visibleCharts = this.state.visibleCharts || [];
    if (visibleCharts[idx] == null) {
      visibleCharts[idx] = {};
    }
    let filterData = visibleCharts[idx].filters || {};
    filterData.selectedKey = keyName;
    visibleCharts[idx].filters = filterData;
    this.setState({ visibleCharts: visibleCharts });
  };

  onChartFilersValueChange = (idx, keyName, valueType) => e => {
    let value = e.target && e.target.value;
    if (value == null && typeof e === "string") {
      value = e;
    }
    const visibleCharts = this.state.visibleCharts || [];
    if (visibleCharts[idx] == null) {
      visibleCharts[idx] = {};
    }
    let filterData = visibleCharts[idx].filters || {};
    filterData[keyName] = {
      ...filterData[keyName],
      [valueType]: value
    };
    visibleCharts[idx].filters = filterData;
    this.setState({ visibleCharts: visibleCharts });
  };

  onChartDataSourceChange = (idx, propName) => value => {
    if (idx == null) {
      this.setState({ [propName]: value });
    } else {
      const visibleCharts = this.state.visibleCharts || [];
      if (visibleCharts[idx] == null) {
        visibleCharts[idx] = {};
      }
      visibleCharts[idx][propName] = value;
      this.setState({ visibleCharts: visibleCharts });
    }
  };

  downloadDeviceData() {
    let payload = this.state.downloadData || {};
    payload["exportType"] = "csv";
    let deviceId =
      this.state.deviceId ||
      (this.props.deviceData && this.props.deviceData.ip_address);
    if (deviceId) {
      downloadDeviceData(this.props.axios, deviceId, payload).then(data => {
        const blob = new Blob([data], { type: "text/csv" });
        // Creating an object for downloading url
        const url = window.URL.createObjectURL(blob);
        // Creating an anchor(a) tag of HTML
        const a = document.createElement("a");

        // Passing the blob downloading url
        a.setAttribute("href", url);

        // Setting the anchor tag attribute for downloading
        // and passing the download file name
        a.setAttribute("download", "device-raw-data.csv");

        // Performing a download with click
        a.click();
        this.setState({ dataDownloadModalOpen: false });
      });
    }
  }

  createFilterableKeyValuePairs(data, parentKey = "") {
    // filterablePairs has data-type, and set of values for that key if the data type is non numeric
    let filterablePairs = {};
    let plotablePairs = {};
    if (data == null) return [filterablePairs, plotablePairs];
    if (typeof data === "object" && !Array.isArray(data)) {
      Object.keys(data).forEach(key => {
        let fullKey = `${parentKey}.${key}`;
        let pairs = this.createFilterableKeyValuePairs(data[key], fullKey);
        filterablePairs = {
          ...filterablePairs,
          ...pairs[0]
        };
        plotablePairs = {
          ...plotablePairs,
          ...pairs[1]
        };
        return [filterablePairs, plotablePairs];
      });
    } else if (Array.isArray(data)) {
      data.forEach((item, _) => {
        let pairs = this.createFilterableKeyValuePairs(item, parentKey);
        filterablePairs = {
          ...filterablePairs,
          ...pairs[0]
        };
        plotablePairs = {
          ...plotablePairs,
          ...pairs[1]
        };
        return [filterablePairs, plotablePairs];
      });
    } else {
      const dataType = typeof data;
      filterablePairs[parentKey] = {
        dataType: dataType,
        values: null
      };
      if (dataType !== "number") {
        const existingValues =
          filterablePairs[parentKey]["values"] || new Set();
        existingValues.add(data);
        filterablePairs[parentKey]["values"] = existingValues;
      }
    }
    if (!isNaN(data) || typeof data === "string") {
      plotablePairs[parentKey] = parentKey;
    }
    return [filterablePairs, plotablePairs];
  }

  filterValue = (idx, status) => {
    const filterCfg = this.state.visibleCharts[idx].filters;
    if (filterCfg == null) return true;
    const filterValue = filterCfg.value && filterCfg.value.toString();
    const minValue = filterCfg.minValue;
    const maxValue = filterCfg.maxValue;

    if (filterCfg.selectedKey == null) return true;

    const keyChain = filterCfg.selectedKey && filterCfg.selectedKey.trim();
    let value = null;
    if (status == null) return false;
    if (keyChain == null) return false;

    if (keyChain.includes(".")) {
      let keys = keyChain.split(".");
      keys.forEach(key => {
        if (status[key] != null) {
          status = status[key];
        }
      });
      value = status;
    } else {
      value = status[keyChain];
    }

    if (value == null) return false;
    if (filterValue != null) {
      if (value.toString().includes(filterValue)) {
        return true;
      }
    }
    if (minValue != null && maxValue != null) {
      if (value >= minValue && value <= maxValue) {
        return true;
      }
    } else if (minValue != null) {
      if (value >= minValue) {
        return true;
      }
    } else if (maxValue != null) {
      if (value <= maxValue) {
        return true;
      }
    }
    if (filterValue == null && minValue == null && maxValue == null) {
      return true;
    }
    return false;
  };

  transformValue = (keyChain, status) => {
    let value = null;
    let dataType = null;
    if (status == null) return value;
    if (keyChain == null) return value;

    keyChain = keyChain.trim(".");
    if (keyChain.includes(".")) {
      let keys = keyChain.split(".");
      keys.forEach(key => {
        if (status[key] != null) {
          status = status[key];
        }
        dataType = key;
      });
      value = status;
    } else {
      value = status[keyChain];
    }
    if (value == null) return value;

    if (dataType === "battery_charging_status") {
      if (value.includes("Charging")) {
        value = value.replace("Charging", "").replace(" W", "");
        return parseFloat(value).toFixed(2);
      }
      if (value.includes("Discharging")) {
        value = value.replace("Discharging", "").replace(" W", "");
        return (-1 * parseFloat(value)).toFixed(2);
      }
    }

    if (
      (dataType === "solar_status" || dataType === "load_status") &&
      typeof value === "string"
    ) {
      return value.replace(" W", "");
    }

    if (
      dataType === "energy_generated_this_day" ||
      dataType === "energy_consumed_this_day"
    ) {
      return value.toFixed(2);
    }

    if (dataType === "net_meter_status") {
      return value;
    }

    if (dataType === "system_temperature" && typeof value === "string") {
      value = value.split(" C, ")[0];
      return parseFloat(value).toFixed(2);
    }

    if (dataType === "system_humidity" && typeof value === "string") {
      value = value.split(" C, ")[1].replace(" H", "");
      return parseFloat(value).toFixed(2);
    }
    return value;
  };

  renderEChart = (chartIdx, chartConfig, chartData) => {
    if (chartConfig == null) return null;
    if (chartData == null) return null;
    let deviceData =
      this.props.deviceData != null
        ? this.props.deviceData
        : this.state.deviceData;
    const tz =
      (deviceData.other_data && deviceData.other_data.timezone) ||
      dayjs.tz.guess();

    let labelField1 = "Power generated(W)";
    let labelField2 = "Power consumed(W)";
    let labelField3 = "Power consumed(W)";
    const selectedKey1 = chartConfig.selectedKey1;
    const selectedKey2 = chartConfig.selectedKey2;
    const selectedKey3 = chartConfig.selectedKey3;

    if (selectedKey1 != null) {
      labelField1 = selectedKey1;
    }

    if (selectedKey2 != null) {
      labelField2 = selectedKey2;
    }

    if (selectedKey3 != null) {
      labelField3 = selectedKey3;
    }

    let chartableData =
      chartData &&
      chartData
        .map(statusData => {
          return {
            data_arrival_time:
              statusData.created_at || statusData.data_arrival_time,
            plot_series_1: this.transformValue(selectedKey1, statusData),
            plot_series_2: this.transformValue(selectedKey2, statusData),
            plot_series_3: this.transformValue(selectedKey3, statusData)
          };
        })
        .filter(dp => {
          return this.filterValue(chartIdx, dp);
        })
        .filter(dp => {
          let allSeriesAreValid =
            (dp.plot_series_1 == null || !isNaN(dp.plot_series_1)) &&
            (dp.plot_series_2 == null || !isNaN(dp.plot_series_2)) &&
            (dp.plot_series_3 == null || !isNaN(dp.plot_series_3));
          return allSeriesAreValid && dp.data_arrival_time != null;
        });

    // sort the chartableData by data_arrival_time
    chartableData = chartableData.sort((a, b) => {
      let data_arrival_time_a = a.data_arrival_time || a.created_at;
      let data_arrival_time_b = b.data_arrival_time || b.created_at;
      return new Date(data_arrival_time_a) - new Date(data_arrival_time_b);
    });

    let dataZoom = [];
    if (chartableData.length > 100) {
      dataZoom = [
        {
          type: "slider",
          start: 0,
          end: 10
        },
        {
          type: "inside",
          start: 0,
          end: 10
        }
      ];
    }

    const weatherIconSize = 80;
    const weatherData = [];
    let lastDrawIdx = 0;

    chartData &&
      chartData.forEach((statusData, _) => {
        let status = statusData.status;
        let dataPoint = status &&
          status.weather &&
          status.weather.weather && {
            data_arrival_time: statusData.created_at,
            description: status.weather.weather[0].description,
            temperature: (status.weather.main.temp / 10).toFixed(1),
            minTemperature: (status.weather.main.temp_min / 10).toFixed(1),
            maxTemperature: (status.weather.main.temp_max / 10).toFixed(1),
            icon: status.weather.weather[0].icon
          };

        if (dataPoint != null) {
          let lastDp = null;
          if (weatherData.length === 0) {
            lastDp = dataPoint;
          } else {
            lastDp = weatherData[lastDrawIdx];
          }

          const screenBigEnough = window.screen.availWidth > 500;

          let timeDiff =
            (new Date(dataPoint.data_arrival_time) -
              new Date(lastDp.data_arrival_time)) /
              3600000 >
            2.5;

          let draw =
            timeDiff &&
            screenBigEnough /*||
              lastDp.description !== dataPoint.description ||
              weatherData.length === 0*/;

          if (draw) {
            lastDrawIdx = weatherData.length;
          }

          weatherData.push({
            data_arrival_time: dataPoint.data_arrival_time,
            description: dataPoint.description,
            icon: `https://openweathermap.org/img/wn/${dataPoint.icon}@2x.png`,
            minTemperature:
              lastDp.minTemperature < dataPoint.temperature
                ? lastDp.minTemperature
                : dataPoint.temperature,
            maxTemperature:
              lastDp.maxTemperature > dataPoint.temperature
                ? lastDp.maxTemperature
                : dataPoint.temperature,
            draw: draw
          });
        }
      });

    const renderWeather = function(param, api) {
      let categoryIndex = api.value(0);
      if (weatherData[categoryIndex].draw !== true) {
        return null;
      }
      let point = api.coord([categoryIndex, 0]);

      return {
        type: "group",
        children: [
          {
            type: "image",
            style: {
              image: weatherData[categoryIndex].icon,
              x: -weatherIconSize / 2,
              y: -weatherIconSize / 2,
              width: weatherIconSize,
              height: weatherIconSize
            },
            position: [point[0], 40]
          },
          {
            type: "text",
            style: {
              text:
                weatherData[param.dataIndex].minTemperature +
                " - " +
                weatherData[param.dataIndex].maxTemperature +
                "°",
              textFont: api.font({ fontSize: 14 }),
              textAlign: "center",
              textVerticalAlign: "bottom"
            },
            position: [point[0], 82]
          }
        ]
      };
    };
    let options = {
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "cross",
          label: {
            backgroundColor: "#6a7985"
          }
        }
      },
      legend: {
        data: [labelField1, labelField2, labelField3]
      },
      toolbox: {
        feature: {
          saveAsImage: {}
        }
      },
      grid: {
        left: "1%",
        right: "1%",
        bottom: "1%",
        containLabel: true
      },
      dataZoom: dataZoom,
      xAxis: [
        {
          boundaryGap: false,
          data: chartableData.map(dp =>
            dayjs(dp.data_arrival_time)
              .tz(tz)
              .format("LT")
          )
        }
      ],
      yAxis: [
        {
          type: "value"
        }
      ],
      series: [
        {
          name: labelField1,
          type: "line",
          areaStyle: {},
          emphasis: {
            focus: "series"
          },
          data: chartableData.map(dp => dp.plot_series_1)
        },
        {
          name: labelField2,
          type: "line",
          areaStyle: {},
          emphasis: {
            focus: "series"
          },
          data: chartableData.map(dp => dp.plot_series_2)
        },
        {
          name: labelField3,
          type: "line",
          areaStyle: {},
          emphasis: {
            focus: "series"
          },
          data: chartableData.map(dp => dp.plot_series_3)
        },
        {
          type: "custom",
          renderItem: renderWeather,
          data: weatherData,
          tooltip: {
            trigger: "item",
            formatter: function(param) {
              return param;
            }
          }
        }
      ]
    };
    return <ReactEcharts option={options} />;
  };

  removeAllFilters = chartIdx => {
    const visibleCharts = this.state.visibleCharts || [];
    const chartCfg = visibleCharts[chartIdx];
    if (chartCfg == null) return;
    chartCfg.filters = {};
    visibleCharts[chartIdx] = chartCfg;
    this.setState({ visibleCharts: visibleCharts });
  };

  renderFilter = chartIdx => {
    const { classes } = this.props;
    const visibleCharts = this.state.visibleCharts || [];
    const chartInputData = visibleCharts[chartIdx];
    return (
      <div className={classes.chartFilters}>
        <div className={classes.chartFilterConfigContainer}>
          <h4>Filters: </h4>
          <div
            className={classes.chartFilterConfigButtonsContainer}
            style={{ display: "flex", gap: "10px" }}
          >
            <Button
              size="sm"
              color="info"
              onClick={() => this.setState({ filterModalOpen: true })}
              justIcon
              round
            >
              <AddCircleIcon />
            </Button>
            <Button
              size="sm"
              color="danger"
              onClick={() => this.removeAllFilters(chartIdx)}
              justIcon
              round
            >
              <DeleteIcon />
            </Button>
          </div>
        </div>
        <div
          className={classes.chartFiltersContainer}
          style={{ position: "relative" }}
        >
          {chartInputData && chartInputData.filters != null ? (
            <div style={{ margin: "5px" }}>
              <div>
                {chartInputData.filters.selectedKey}:{" "}
                {
                  chartInputData.minValue // Show minValue if exists
                }{" "}
                {chartInputData.filters.minValue && " to "}{" "}
                {chartInputData.filters.maxValue // Show maxValue if exists
                  ? chartInputData.filters.maxValue
                  : null}{" "}
                {
                  chartInputData.startDate // Show startDate if exists
                }{" "}
                {chartInputData.filters.startDate && " to "}{" "}
                {chartInputData.filters.endDate // Show endDate if exists
                  ? chartInputData.filters.endDate
                  : null}{" "}
                {chartInputData.filters.value // Show value if exists
                  ? chartInputData.filters.value
                  : ""}
              </div>
            </div>
          ) : null}
        </div>
        <Modal
          hideBackdrop
          open={this.state.filterModalOpen}
          onClose={() => this.setState({ filterModalOpen: false })}
          aria-labelledby="Add Filter"
          aria-describedby="Add a new filter"
        >
          <Box className={classes.alarmModalBox} sx={{ width: 300 }}>
            <div className={classes.alarmSelectionContainer}>
              <label className={classes.chartTypeLabel}>Select Key</label>
              <CustomSelect
                className={classes.dataSourceSelector}
                labelText="Select Key"
                items={
                  (chartInputData &&
                    chartInputData.dataKeys &&
                    Object.keys(chartInputData.dataKeys).map(key => ({
                      text: key,
                      value: key
                    }))) ||
                  []
                }
                onChange={this.onChartFilersKeyChange(chartIdx)}
              />
            </div>
            <div className={classes.alarmSelectionContainer}>
              <label className={classes.chartTypeLabel}>Select Value</label>
              {chartInputData &&
                chartInputData.filters &&
                chartInputData.filters.selectedKey &&
                (() => {
                  const selectedKey = chartInputData.filters.selectedKey;
                  const dataType =
                    chartInputData.dataKeys &&
                    chartInputData.dataKeys[selectedKey] &&
                    chartInputData.dataKeys[selectedKey].dataType;
                  if (dataType === "number") {
                    return (
                      <div>
                        <label>Min:</label>
                        <input
                          type="number"
                          onChange={e =>
                            this.onChartFilersValueChange(
                              chartIdx,
                              selectedKey,
                              "minValue"
                            )(e)
                          }
                        />
                        <label>Max:</label>
                        <input
                          type="number"
                          onChange={e =>
                            this.onChartFilersValueChange(
                              chartIdx,
                              selectedKey,
                              "maxValue"
                            )(e)
                          }
                        />
                      </div>
                    );
                  } else if (dataType === "date") {
                    return (
                      <div>
                        <label>Start Date:</label>
                        <Datetime
                          timeFormat={false}
                          onChange={date =>
                            this.onChartFilersValueChange(
                              chartIdx,
                              selectedKey,
                              "startDate"
                            )({
                              target: { value: date }
                            })
                          }
                        />
                        <label>End Date:</label>
                        <Datetime
                          timeFormat={false}
                          onChange={date =>
                            this.onChartFilersValueChange(
                              chartIdx,
                              selectedKey,
                              "endDate"
                            )({
                              target: { value: date }
                            })
                          }
                        />
                      </div>
                    );
                  } else if (
                    chartInputData &&
                    chartInputData.dataKeys &&
                    chartInputData.dataKeys[selectedKey] &&
                    chartInputData.dataKeys[selectedKey].values
                  ) {
                    return (
                      // Add a select dropdown if there are limited values
                      <CustomSelect
                        className={classes.dataSourceSelector}
                        labelText="Select Value"
                        items={
                          Array.from(
                            chartInputData.dataKeys[selectedKey].values
                          ).map(val => ({
                            text: val,
                            value: val
                          })) || []
                        }
                        onChange={this.onChartFilersValueChange(
                          chartIdx,
                          selectedKey,
                          "value"
                        )}
                      />
                    );
                  } else {
                    return (
                      <input
                        type="text"
                        onChange={e =>
                          this.onChartFilersChange(chartIdx, "value")(e)
                        }
                      />
                    );
                  }
                })()}
            </div>
            <div className={classes.alarmSelectionContainer}>
              <Button
                onClick={() => {
                  this.setState({
                    filterModalOpen: false
                  });
                }}
              >
                Add
              </Button>
              <Button onClick={() => this.setState({ filterModalOpen: false })}>
                Cancel
              </Button>
            </div>
          </Box>
        </Modal>
      </div>
    );
  };

  renderChart(chartIdx) {
    const { classes } = this.props;
    const visibleCharts = this.state.visibleCharts || [];
    const chartInputData = visibleCharts[chartIdx];
    let allStatusData = (chartInputData && chartInputData.statusData) || [];
    return (
      <div>
        <div className={classes.chartSelectionContainer}>
          <FormControl fullWidth>
            <FormLabel className={classes.chartTypeLabel} component="legend">
              Start Time
            </FormLabel>
            <Datetime
              timeFormat={true}
              onChange={this.onChartInputsChange(chartIdx, "startTime")}
            />
          </FormControl>
          <FormControl fullWidth>
            <FormLabel className={classes.chartTypeLabel} component="legend">
              End Time
            </FormLabel>
            <Datetime
              timeFormat={true}
              onChange={this.onChartInputsChange(chartIdx, "endTime")}
            />
          </FormControl>
        </div>
        <div className={classes.chartSelectionContainer}>
          <label className={classes.chartTypeLabel}>Source</label>
          <CustomSelect
            className={classes.dataSourceSelector}
            labelText={chartInputData && chartInputData.dataType}
            items={AVAILABLE_DATA_SOURCES}
            onChange={this.onChartInputsChange(chartIdx, "dataType")}
          />
        </div>
        <div className={classes.chartSelectionContainer}>
          <CustomSelect
            className={classes.dataSourceSelector}
            labelText="Select Key 1 to plot"
            items={
              (visibleCharts[chartIdx] &&
                visibleCharts[chartIdx].plotableKeys &&
                Object.keys(visibleCharts[chartIdx].plotableKeys).map(key => ({
                  text: key,
                  value: key
                }))) ||
              []
            }
            onChange={this.onChartInputsChange(chartIdx, "selectedKey1")}
          />
        </div>
        <div className={classes.chartSelectionContainer}>
          <CustomSelect
            className={classes.dataSourceSelector}
            labelText="Select Key 2 to plot"
            items={
              (visibleCharts[chartIdx] &&
                visibleCharts[chartIdx].plotableKeys &&
                Object.keys(visibleCharts[chartIdx].plotableKeys).map(key => ({
                  text: key,
                  value: key
                }))) ||
              []
            }
            onChange={this.onChartInputsChange(chartIdx, "selectedKey2")}
          />
        </div>
        <div className={classes.chartSelectionContainer}>
          <CustomSelect
            className={classes.dataSourceSelector}
            labelText="Select Key 3 to plot"
            items={
              (visibleCharts[chartIdx] &&
                visibleCharts[chartIdx].plotableKeys &&
                Object.keys(visibleCharts[chartIdx].plotableKeys).map(key => ({
                  text: key,
                  value: key
                }))) ||
              []
            }
            onChange={this.onChartInputsChange(chartIdx, "selectedKey3")}
          />
        </div>
        {this.renderFilter(chartIdx)}
        {this.renderEChart(chartIdx, chartInputData, allStatusData)}
      </div>
    );
  }

  render() {
    // eslint-disable-next-line no-unused-vars
    const { classes } = this.props;
    let deviceData =
      this.props.deviceData != null
        ? this.props.deviceData
        : this.state.deviceData;
    if (deviceData == null) return null;
    return (
      <div className={classes.alarmsContainer}>
        <div style={{ paddingTop: "30px" }}>
          {this.state.visibleCharts &&
            this.state.visibleCharts.map((_, idx) => {
              return (
                <div key={`chart-${idx}`} style={{ position: "relative" }}>
                  <div className={classes.chartHeaderContainer}>
                    <h3>
                      <strong>{`Chart [${idx}]`}</strong>
                    </h3>
                    <Button
                      size="sm"
                      color="danger"
                      onClick={() => {
                        const visibleCharts = [...this.state.visibleCharts];
                        visibleCharts.splice(idx, 1);
                        this.setState({ visibleCharts });
                      }}
                      justIcon
                      round
                    >
                      <CloseIcon />
                    </Button>
                  </div>
                  {this.renderChart(idx)}
                </div>
              );
            })}
        </div>
        <div className={classes.alarmActions}>
          <Button
            size="sm"
            color="info"
            className={classes.marginRight}
            onClick={_ => this.addNewChart()}
            justIcon
            round
          >
            <AddCircleIcon />
          </Button>
        </div>
      </div>
    );
  }
}

AdvancedCharts.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withStyles(styles)(AdvancedCharts);
